import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminMediaPartnersMediaPartnerRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ media_partner_id }) {
    const { content } = await this.store.request(
      findRecord('media-partner', media_partner_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
